"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const getPostTitle_1 = __importDefault(require("../../utils/getPostTitle"));
const gatsby_theme_leshen_1 = require("../../../../gatsby-theme-leshen");
const formatDate_1 = __importDefault(require("../../utils/formatDate"));
function mapToSplitModuleProps({ data, mappers, inHero, packages, forms, title, author, publishDate, }) {
    const { alignImageToBottom, alignMobileImageToBottom, backgroundColor, textColor, mobileTextColor, topPadding, bottomPadding, jumpLinkId: jumplink, width, id, mainContent, modules, } = data;
    let image = null;
    if (data.desktopMedia?.length) {
        image = mappers.mapBlock({
            block: data.desktopMedia[0],
            mappers,
        });
    }
    let mobileImage = null;
    if (data.mobileMedia?.length) {
        mobileImage = mappers.mapBlock({
            block: data.mobileMedia[0],
            mappers,
        });
    }
    let backgroundImage = null;
    if (data.backgroundImage?.length) {
        backgroundImage = mappers.mapBlock({
            block: data.backgroundImage?.[0],
            mappers,
            packages,
        });
    }
    let mobileBackgroundImage = null;
    if (data.mobileBackgroundImage?.length) {
        mobileBackgroundImage = mappers.mapBlock({
            block: data.mobileBackgroundImage?.[0],
            mappers,
            packages,
        });
    }
    let content;
    const { postTitle } = (0, getPostTitle_1.default)({
        title,
        publishDate,
        author,
        mappers,
        inHero: inHero ?? false,
        packages,
        forms,
    });
    if (mainContent) {
        content = mappers.mapRichText({
            richText: mainContent,
            mappers,
            inHero,
            packages,
            forms,
        });
    }
    return {
        image,
        mobileImage,
        backgroundImage,
        mobileBackgroundImage,
        alignImageToBottom,
        alignMobileImageToBottom,
        backgroundColor,
        textColor,
        mobileTextColor,
        topPadding,
        bottomPadding,
        jumplink,
        width,
        id,
        mainContent: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [postTitle && postTitle, publishDate && author?.fullName && ((0, jsx_runtime_1.jsx)(gatsby_theme_leshen_1.AuthorLine, { date: (0, formatDate_1.default)({ date: publishDate }), fullName: author?.fullName })), content] })),
        children: modules?.length
            ? mappers.mapBlock({ block: modules[0], mappers, inHero, packages })
            : null,
    };
}
exports.default = mapToSplitModuleProps;
